export default __webpack_public_path__ + "static/media/rain.6fae8b52.svg";